import { cn } from "@/utils/utils";
import { DiscountAmoutType } from "@/types";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ChevronDown } from "lucide-react";
import FormField from "../common/FormField";

interface DiscountAmountFieldProps {
  value: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  selectedType: DiscountAmoutType;
  onTypeChange: (type: DiscountAmoutType) => void;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

const DiscountAmountField = ({
  value,
  onChange,
  error,
  selectedType,
  onTypeChange,
  isOpen,
  setIsOpen,
}: DiscountAmountFieldProps) => {
  return (
    <FormField
      label="Discount Amount"
      id="discountValue"
      name="discountValue"
      value={value}
      onChange={onChange}
      error={error}
      placeholder="Enter amount"
    >
      <div
        className={cn(
          "relative flex overflow-hidden p-0",
          "h-12 rounded-lg border border-[#E2E8F0]",
        )}
      >
        <div className="flex w-[90%] items-center p-2 max-sm:w-[85%] max-sm:gap-2">
          <div className="max-sm:w-2/5">
            <Popover open={isOpen} onOpenChange={setIsOpen}>
              <PopoverTrigger>
                <div className="flex items-center justify-between bg-button-background px-4 py-2 text-neutral-950 max-sm:w-full max-sm:gap-1 max-sm:rounded-[8px] max-sm:px-2">
                  <span className="max-sm:text-xs">{selectedType}</span>
                  <ChevronDown className="size-4 max-sm:size-3" />
                </div>
              </PopoverTrigger>
              <PopoverContent align="start" className="w-[133px]">
                <div className="flex cursor-pointer flex-col gap-2">
                  <div
                    onClick={() => {
                      onTypeChange(DiscountAmoutType.FIXED_AMOUNT);
                      setIsOpen(false);
                    }}
                  >
                    Fixed
                  </div>
                  <div
                    onClick={() => {
                      onTypeChange(DiscountAmoutType.PERCENTAGE);
                      setIsOpen(false);
                    }}
                  >
                    Percentage
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>

          <input
            id="discountValue"
            type="number"
            name="discountValue"
            placeholder="Enter amount"
            className={cn(
              "h-full flex-1 px-3 outline-none placeholder:text-[#94A3B8] max-sm:ml-auto max-sm:w-2/5 bg-white",
            )}
            onChange={onChange}
            value={value}
          />
        </div>

        <div className="pointer-events-none ml-auto flex w-[68px] items-center justify-center border-l bg-[#F6F9FB] max-sm:w-12">
          <span className="text-[16px] font-semibold text-[#94A3B8]">
            {selectedType === DiscountAmoutType.PERCENTAGE ? "%" : "USD"}
          </span>
        </div>
      </div>
    </FormField>
  );
};

export default DiscountAmountField;
